<template>
	<touch-suggester-part v-if="visible && env.touch" :part="part" :data="data" :readonly="readonly" :viewmode="viewmode" @suggested="onSuggested"></touch-suggester-part>
	<desktop-suggester-part v-else-if="visible" :part="part" :data="data" :readonly="readonly" :viewmode="viewmode" @suggested="onSuggested"></desktop-suggester-part>
</template>

<script setup lang="ts">
import DesktopSuggesterPart from "./DesktopSuggesterPart.vue";
import TouchSuggesterPart from "./TouchSuggesterPart.vue";
import {type PartProps, partProps} from "../../Part";
import useEditor from "../Editor";
import {injectEnv} from "../../Environment";

const uprops = defineProps({...partProps});
const props = uprops as PartProps;

const emit = defineEmits(["suggested"]);

const {visible, value, clazz, style, ro} = useEditor(props);
const env = injectEnv();

function onSuggested() {
	emit("suggested");
}
</script>

<style></style>
